
import DevConfirmationModalTest from "./dev/DevConfirmationModalTest";
import { EnrollmentSequence } from "./components/Sequence/EnrollmentSequence";
import ApplyPage from "./components/Pages/ApplyPage";
import LogOut from "./components/Pages/LogOut";
import IndexPage from "./components/Pages/IndexPage";
import TestPage from "./tests/TestPage";
import PaymentComplete from "./components/Pages/PaymentComplete";
import ConfirmationPage from "./components/Pages/ConfirmationPage";
import AgreementToDoBusiness from "./components/Pages/AgreementToDoBusiness";
import ResetPassword from "./components/Forms/ResetPassword";
import UiStencil from "./components/Pages/UiStencil";

// Development-only routes
const devRoutes = process.env.NODE_ENV !== "production"
  ? [{ path: "/dev-confirmation-modal-test", element: <DevConfirmationModalTest /> }]
  : [];






const AppRoutes: Array<any> = [
    ...devRoutes,
    {
      path: '/test',
      element: <TestPage/>,
    },
    {
        path: '/stencil',
        element: <UiStencil />
    },
    {
        path: '/agreement-to-do-business-with-gallagher',
        element: <AgreementToDoBusiness />
    },
    {
        path: '/confirmation',
        element: <ConfirmationPage/>,
    },
    {
      path: '/apply/:productKey',
      element: <ApplyPage />
    },
    {
        path: '/:productKey',
        element: <EnrollmentSequence sponsor="American Federation of Teachers" />
    },
    {
        path: ':productKey/payment-complete',
        element: <PaymentComplete />
    },
    {
        path: '/logout',
        element: <LogOut />
    },
    {
        path: '/',
        element: <IndexPage />,
        index: true
    },
    {
        path: '/reset-password/:token',
        element: <ResetPassword />,
        index: true
    }
];

export default AppRoutes;